type Props = {
  onResume: () => void;
  onDiscard: () => void;
};

export function ResumePrompt({ onResume, onDiscard }: Props) {
  return (
    <div
      role="dialog"
      aria-label="resume run"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 16, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
    >
      <div
        className="terminal-frame"
        style={{
          maxWidth: '20rem',
          padding: 'var(--space-5)',
          background: 'var(--bg)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-3)',
        }}
      >
        <span className="corner-tr" />
        <span className="corner-bl" />
        <div className="label glow-warning" style={{ letterSpacing: '0.1em' }}>
          // RUN INTERRUPTED
        </div>
        <p style={{ fontSize: '0.8rem', color: 'var(--fg-text-dim)', lineHeight: 1.5 }}>
          A previous run was not finished. Continue where you left off?
        </p>
        <div style={{ display: 'flex', gap: 'var(--space-2)', justifyContent: 'center' }}>
          <button className="primary" onClick={onResume}>RESUME</button>
          <button className="ghost" onClick={onDiscard}>DISCARD</button>
        </div>
      </div>
    </div>
  );
}
